import { useContext } from 'react';
import { Grid, Tooltip } from '@mui/material';
import { SVGIconComponent } from '../../icons/types';
import { useDeliveryContainerTileContentStyles } from './delivery-container-tile-content.styles';
import { DeliveryContainerReserveeChip } from '../../delivery-container-reservee-chip/delivery-container-reservee-chip.component';
import { PartyModel } from '../../../../../features/lockers/models/party.model';
import { PermissionBoundary } from '../../../../../core/permissions/permission-boundary.component';
import { DeliveryContainerTileTooltipContext } from '../delivery-container-tile/delivery-container-tile.component';

export type DeliveryContainerTileContentProps = {
  deliveryContainerName: string;
  reservedForRecipients?: PartyModel[];
  Icon?: SVGIconComponent;
  RightIcon?: SVGIconComponent;
  rightIconTooltip?: React.ReactNode;
  minimiseReserveeChip?: boolean;
  reserveeChipVerticalPosition?: 'center' | 'bottom';
};

export function DeliveryContainerTileContent(props: DeliveryContainerTileContentProps) {
  const classes = useDeliveryContainerTileContentStyles(props);
  const { suppressTooltip, unsuppressTooltip } = useContext(DeliveryContainerTileTooltipContext);

  const recipientLabels = props.reservedForRecipients?.map((recipient) => recipient.minimisedDisplayName) || [];
  const recipientTooltipLabels = props.reservedForRecipients?.map((recipient) => recipient.name) || [];

  return (
    <Grid
      className={classes.root}
      container
      wrap="nowrap"
      sx={{
        justifyContent: 'space-between',
        alignItems: 'center'
      }}
    >
      <Grid>
        <Grid
          container
          wrap="wrap"
          className={classes.deliveryContainer}
          sx={{
            alignItems: 'center'
          }}
        >
          <Grid>{props.Icon ? <props.Icon className={classes.icon} /> : ''}</Grid>
          <Grid>
            <p className={classes.deliveryContainerName}>{props.deliveryContainerName}</p>
          </Grid>
        </Grid>
      </Grid>
      {props.RightIcon && (
        <Grid className={classes.rightIconContainer} onMouseEnter={suppressTooltip} onMouseLeave={unsuppressTooltip}>
          {props.rightIconTooltip ? (
            <Tooltip title={props.rightIconTooltip} arrow>
              <span className={classes.rightIconWrapper}>
                <props.RightIcon className={classes.rightIcon} />
              </span>
            </Tooltip>
          ) : (
            <props.RightIcon className={classes.rightIcon} />
          )}
        </Grid>
      )}
      {props.reservedForRecipients && props.reservedForRecipients.length > 0 && (
        <PermissionBoundary availableUiFeatures={['internal-groundfloor']}>
          <div
            className={classes.reserveeChipsContainer}
            onMouseEnter={suppressTooltip}
            onMouseLeave={unsuppressTooltip}
          >
            <DeliveryContainerReserveeChip
              labels={recipientLabels}
              tooltipLabels={recipientTooltipLabels}
              minimised={props.minimiseReserveeChip}
            />
          </div>
        </PermissionBoundary>
      )}
    </Grid>
  );
}
